<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="pop-content-search" v-if="isUpload">
                <el-form size="mini" label-width="100px">
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="이미지 파일">
                                <el-input type="text" size="mini" v-model="fileStr" readonly="readonly"/>
                                <input ref="file" type="file" accept="image/*" @change="fileChangeEvent" hidden multiple/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" size="mini" icon="el-icon-files" @click="uploadArea">
                                파일찾기
                            </el-button>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="success" size="mini" icon="el-icon-upload2" @click="uploadFile">
                                업로드
                            </el-button>
                        </el-col>
                        <el-col :span="1">
                            <el-divider direction="vertical"></el-divider>
                        </el-col>
                        <el-col :span="4" v-if="isUpload">
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteFile">
                                삭제
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div class="table-area" v-show="attachYn  === 'Y' ">
                <div class="table-b">
                    <ag-grid-vue
                        style="width: 100%; height: 320px;"
                        class="ag-theme-alpine"
                        row-selection="single"
                        :column-defs="columnDefs"
                        :grid-options="gridOptions"
                        :row-data="subData"
                        :context="context"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @cell-clicked="onCellClicked"
                        @grid-ready="onGridReady"
                        />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';
// import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

import FieldImgModal from './FieldImgModal.vue';
/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: {
        srcId2: {
            Type: String
            , required: false
        },
        srcId3: {
            Type: String
            , required: false
        },
        attachYn: {
            Type: String
            , required: false
        },
        isUpload: {
            Type: Boolean,
            default: true
        },
    },
    components: {Layout, AgGridVue},
    data() {
        return {
            rowCount:0,
            enableUploadArea: false,
            file : "",
            // file: {
            //     name: undefined
            // },
            fileStr: "",
            fileLoaded: false,

            // AG-GRID OPTION [START]
            subData:[],
            tempData:[],
            gridOptions: {},
            
            maker: '', /** 제조사 */
            makerList: [], /** 제조사 리스트*/
            modelGroup: '', /** 제품군 */
            modelGroupList: [], /** 제품군 리스트*/
            modelGroupNmList: [], /** 제품군 명칭 리스트*/
            subModelGroup: '', /** 제품군 */
            subModelGroupList: [], /** 제품군 리스트*/
            subModelGroupShow: false,
            standardModelNm: '', /** 대표모델 */
            modelNm: '', /** 모델 */
            setupGroupId: '',

            columnDefs:[
                {
                    field:'chk', 
                    width:80,
                    hide: !this.isUpload,
                    headerComponent: `checkbox`,
                    headerComponentParams: (params) => {
                        return params;
                    },
                    cellStyle : {textAlign: 'center'},
                    cellRenderer: 'checkbox',
                    cellRendererParams: (params) => {
                        return {
                            trueValue: 'Y',
                            falseValue: 'N',
                            disable: false
                        }
                    }
                },
                {
                    headerName: '파일명',
                    width:400,
                    field:'originalName',
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '경로',
                    width:400,
                    field:'downloadUrl',
                    cellStyle:{textAlign:'center'},
                    cellRenderer: (params) => {
                        return `<div 
                            style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">
                            ${params.value}
                        </div>`;
                    },
                },
            ],
            context: {
                headerAllCheckEvent: this.allCheckEvnet,
            },
            frameworkComponent : {
                'checkbox': CheckboxCellRenderer,
            },
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            form: {}
        }
    },
    computed: {
        title() {
            console.log("this.isUpload ", this.isUpload)
            return `${this.isUpload == true ? '자재 이미지 업로드' : '자재 이미지'}`;
        }
    },
    mounted() {
        // this.form = this.tabData[0] ? this.tabData[0].param : {}
      console.log(this.attachYn);
      console.log(this.srcId2);
      console.log(this.srcId3);
        if(this.attachYn === 'Y') {
          this.getImageList(this.srcId2);
        }
    },
    methods: {
        /**
         * grid 내에 체크박스 전체 체크 함수
         * @param {*} field 
         * @param {*} checked 
         */
        allCheckEvnet(field, checked) {
            return this.subData = this.subData.map(x => {
                x[field] = checked ? 'Y' : 'N' ;
                return x;
            })
        },
        uploadArea() {
            if(!this.fileLoaded) {
                this.$confirm('자재 이미지 파일 업로드를 진행 하시겠습니까?', '파일 업로드', {
                    confirmButtonText: '확인',
                    cancelButtonText: '취소',
                    type: 'info'
                }).then(() => {
                    this.searchFile();
                }).catch(err => {
                    console.log("err ", err)
                    this.$message({
                    type: 'warning',
                    message: '취소되었습니다.'
                    });
                })
            } else {
                this.searchFile();
            }
        },
        searchFile() {
            this.$refs.file.click()
        },
        fileChangeEvent() {

            this.file = this.$refs.file.files;

            for(var i = 0 ; this.file.length > i ; i++){
              if(i == 0){
                this.fileStr = this.$refs.file.files[i].name;
              }else{
                this.fileStr = this.fileStr + ',' + this.$refs.file.files[i].name;
              }
            }

            this.fileLoaded = this.$refs.file.files[0] !== undefined
        },
        getImageList(id){
          this.$store.commit('loading');
          this.$http.get(`/api/materialsMng/img/list/${id}`)
              .then(response => {
                this.subData = response.data.files;
          }).catch(response => {
            this.$swal({
              type: 'error',
              text: response.data
            });
          }).finally(() => {
            this.$store.commit('finish');
          })

        },
        uploadFile() {
            if (this.fileLoaded) {
                let form = new FormData();
                const id = this.srcId2;
                const group = this.srcId3;

                for(var i = 0; i < this.file.length; i++){
                    form.append('files', this.file[i]);
                }

                this.$store.commit('loading');
                this.$http.post(`/api/materialsMng/img/upload/${id}/${group}`, form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    
                    this.subData = response.data;
                    this.$swal({
                        type: 'success',
                        text: '업로드에 성공했습니다.'
                    }).then(result => {
                        if(result) {
                            this.closeModal();
                        }
                    });

                }).catch(response => {
                    this.$swal({
                        type: 'error',
                        text: response.data.message
                    });

                    this.setupGroupId = 0;

                }).finally(() => {
                    this.fileStr = "";
                    this.file = "";
                    // this.enableUploadArea = false;
                    this.$store.commit('finish');
                })
            } else {
                this.$swal({
                    type: 'warning',
                    text: '업로드할 파일을 선택해주세요.'
                })
            }
        },
        deleteFile() {
            console.log("this.srcId2 ", this.srcId2)
            const chk = this.subData.filter(f => f.chk === 'Y');
            if(chk.length > 0) {
                this.$store.commit('loading');
                this.$http.post(`/api/materialsMng/img/delete/${this.srcId2}`, chk)
                .then(res => {
                    this.$swal({
                        type: 'success',
                        text: `${res.data}`
                    }).then(result => {
                        if(result) {
                            //this.getImageList(this.srcId2);
                            this.closeModal();
                        }
                    })
                })
                .catch(err => {
                    this.$swal({
                        type: 'error',
                        text: `${err.response.data.message}`
                    })
                })
                .finally(() => {

                    this.$store.commit('finish');
                })
                //삭제 진행
            } else {
                this.$swal({
                    type: 'info',
                    text: '삭제 할 파일을 선택해주세요.'
                })
            }
        },
        
        closeModal() {
            this.$parent.close();
            this.$emit('close', true);
        },
        onGridReady(){

        },
        onCellClicked(params) {
            if(params.colDef.field === 'downloadUrl'){
                this.openFieldImgModel(params.data)
            } else if(params.colDef.field === 'deleteYn') {
                alert("delete")
            }
        },
        
        openFieldImgModel(param) {
            console.log("openFieldImgModel params ", param);
            /** 이미지 팝업 */

            let vm = this;
            this.$modal.open({
                width: 950,
                component: FieldImgModal,
                parent: this,
                props: {
                    data: param,
                    title: `자재 이미지`
                },
                events: {
                    close(data) {
                        console.log('close', data);
                    },
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>